import { Button, Group, Stack } from "@mantine/core";
import { IconArrowLeft } from "@tabler/icons-react";
import { Link } from "react-router-dom";

import { SpecimenLogReportContent } from "./SpecimenLogReportContent";

export default function SpecimenLogReportPage() {
  return (
    <Stack gap="lg" p="md">
      <Group>
        <Button
          component={Link}
          to="/reports"
          variant="subtle"
          leftSection={<IconArrowLeft size={16} />}
        >
          Reports
        </Button>
      </Group>
      <SpecimenLogReportContent />
    </Stack>
  );
}
